import React from "react";
import { Button, Modal } from "react-bootstrap";
import { SpinnerKonecta } from "../layout/spinner/Spinner";
import { IMessage } from "../model/message.model";
import { ConfirmQuestion } from "./body-modal/confirm-question";
import { ErrorRequest } from "./body-modal/error-request";
import { SuccessRequest } from "./body-modal/success-request";

interface IProps {
  loading: boolean;
  errorMessage: any;
  updateSuccess: boolean;
  messageSuccess: IMessage;
  handleClose: () => void;
  setShowModalConfirm: (data: boolean) => void;
  saveConfirm: () => void;
}
export const ModalResponse = (props: IProps) => {
  const {
    loading,
    errorMessage,
    updateSuccess,
    messageSuccess: message,
    handleClose,
    setShowModalConfirm,
    saveConfirm,
  } = props;
  return (
    <Modal show={true} backdrop="static" centered className="modal-generic">
      {loading ? (
        <div className="loading-modal">
          <SpinnerKonecta /> Procesando tu solicitud...
        </div>
      ) : updateSuccess ? (
        <>
          <SuccessRequest message={message} />
          <Modal.Footer className="d-flex w-100 justify-content-end">
            <Button onClick={handleClose} className="save-modal">
              Aceptar
            </Button>
          </Modal.Footer>
        </>
      ) : errorMessage ? (
        <>
          <ErrorRequest errorMessage={errorMessage} />
          <Modal.Footer>
            <Button onClick={handleClose} className="cancel-error">
              Aceptar
            </Button>
          </Modal.Footer>
        </>
      ) : (
        <>
          <ConfirmQuestion />
          <Modal.Footer>
            <Button
              onClick={() => setShowModalConfirm(false)}
              className="cancel-modal"
            >
              Cancelar
            </Button>
            <Button onClick={saveConfirm} className="save-modal">
              Aceptar
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};
